import {
  SALARY_LIST_REQUEST,
  SALARY_LIST_SUCCESS,
  SALARY_LIST_FAIL,
  SALARY_LIST_RESET,
} from '../constants/salaryConstants';

export const salaryListReducer = (state = { salaries: null }, action) => {
  switch (action.type) {
    case SALARY_LIST_REQUEST:
      return { loading: true, salaries: null };

    case SALARY_LIST_SUCCESS:
      return { 
        loading: false, 
        salaries: action.payload,
        periodData: {
          start_date: action.payload.formatted_start_date,
          end_date: action.payload.formatted_end_date,
          firstPaymentDate: action.payload.formatted_first_payment_date,
          lastPaymentDate: action.payload.formatted_last_payment_date,
        },
        nettoSalaries: action.payload.rates.map(rate => ({
          type: rate.year_type_display,
          percentage: `${rate.percentage}%`,
          amount: `${parseFloat(rate.netto_amount).toFixed(2)} zł`,
          color: rate.color
        })),
        bruttoData: action.payload.rates.map(rate => ({
          year: rate.year_type_display,
          netto: `${parseFloat(rate.netto_amount).toFixed(2)} zł`,
          podstawa: `${parseFloat(rate.podstawa).toFixed(2)} zł`,
          emerytalne: {
            platnik: `${parseFloat(rate.emerytalne_platnik).toFixed(2)} zł`,
            ubezpieczony: `${parseFloat(rate.emerytalne_ubezpieczony).toFixed(2)} zł`
          },
          rentowe: {
            platnik: `${parseFloat(rate.rentowe_platnik).toFixed(2)} zł`,
            ubezpieczony: `${parseFloat(rate.rentowe_ubezpieczony).toFixed(2)} zł`
          },
          chorobowe: {
            platnik: '-',
            ubezpieczony: `${parseFloat(rate.chorobowe_ubezpieczony).toFixed(2)} zł`
          },
          wypadkowe: {
            platnik: rate.wypadkowe_info,
            ubezpieczony: '-'
          },
          podstawaZdrowotna: `${parseFloat(rate.podstawa_zdrowotna).toFixed(2)} zł`,
          zdrowotne: {
            platnik: '-',
            ubezpieczony: `${parseFloat(rate.zdrowotne_podstawowe).toFixed(2)} zł** / ${parseFloat(rate.zdrowotne_podwyzszone).toFixed(2)} zł***`
          },
          color: rate.color
        }))
      };

    case SALARY_LIST_FAIL:
      return { loading: false, error: action.payload };

    case SALARY_LIST_RESET:
      return { salaries: null };

    default:
      return state;
  }
};